/* wsapi3-wsjs v1.0 */
/* Deploy Version 2026-09-23 13:37:25 */
/* Deploy Version 2026-07-27 16:11:03 */
/* ws-wsjs v2.0 */
let ApiWS = {
    logs: {
        restCalls: []
    },

    Cookie: {
        name(key, window) {
            const d = new Date();
            const day = `${d.getDate()}-${d.getMonth()}`;
            const hour = d.getHours();
            const minute = d.getMinutes();
            const half = minute < 30 ? 1 : 2;
            const suffix = { D: `_${day}`, H: `_${day}_${hour}`, M10: `_${day}_${hour}_${minute.toString()[0]}`, M30: `_${day}_${hour}_${half}` }[window] || '';
            const clientId = document.querySelector('#HD_LVCLI_ID')?.value || '';
            const b2b = document.querySelector('#LV_USU_B2B')?.value || '';
            const token = document.querySelector('#HdTokenLojaTemp')?.value || '';
            const base = clientId && clientId !== '0' ? `${token}_${clientId}` : token;
            return `${base}${key}${b2b}${suffix}`;
        },
        set(key, window, value) {
            try {
                if (typeof nPanel != 'undefined' && nPanel.token) return;
                localStorage[ApiWS.Cookie.name(key, window)] = JSON.stringify(value);
            } catch (e) {
                if (e.message?.includes('exceeded the quota')) localStorage.clear();
            }
        },
        get(key, window) {
            try { return JSON.parse(localStorage[ApiWS.Cookie.name(key, window)]); }
            catch { return false; }
        }
    },

    // Origem do visitante (UTMs + referrer externo), capturada na 1ª página da sessão e
    // enviada como `origin` em todo /cart/items/add (o backend grava 1x por pedido).
    Origin: {
        KEY: 'ws_origin',
        MAX: 255,
        // Cookie de sessão (sem expires): compartilhado entre abas, some ao fechar o navegador.
        _read() {
            const m = document.cookie.match(new RegExp('(?:^|;\\s*)' + ApiWS.Origin.KEY + '=([^;]*)'));
            return m ? m[1] : null;
        },
        _write(origin) {
            let value = encodeURIComponent(JSON.stringify(origin));
            if (value.length > 3500) { // limite de ~4KB por cookie: sacrifica o referrer primeiro
                const { referrer, ...rest } = origin;
                value = encodeURIComponent(JSON.stringify(rest));
            }
            document.cookie = `${ApiWS.Origin.KEY}=${value}; path=/; SameSite=Lax${location.protocol === 'https:' ? '; Secure' : ''}`;
        },
        capture() {
            try {
                if (ApiWS.Origin._read() !== null) return; // já capturada: navegação interna não sobrescreve
                const origin = {};
                const params = new URLSearchParams(window.location.search);
                ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term'].forEach(k => {
                    const v = (params.get(k) || '').trim();
                    if (v) origin[k] = v.slice(0, ApiWS.Origin.MAX);
                });
                const ref = (document.referrer || '').trim();
                if (ref) {
                    try {
                        const strip = h => h.toLowerCase().replace(/^www\./, '');
                        if (strip(new URL(ref).hostname) !== strip(window.location.hostname)) origin.referrer = ref.slice(0, ApiWS.Origin.MAX);
                    } catch (e) { }
                }
                ApiWS.Origin._write(origin);
            } catch (e) { }
        },
        get() {
            try {
                const raw = ApiWS.Origin._read();
                const o = raw ? JSON.parse(decodeURIComponent(raw)) : null;
                return o && Object.keys(o).length ? o : null;
            } catch (e) { return null; }
        }
    },

    Calls: {
        // ----------------------------------------------------------------
        // Helpers de fetch
        // ----------------------------------------------------------------

        // Lê os params de filtro e ordenação da URL atual e converte para os parâmetros da API v3.
        // URL front:  ?mf=id    → API: man_id=id   (single; API não suporta múltiplos)
        // URL front:  ?pr=id    → API: price_id=id
        // URL front:  ?cf_{N}=  → API: charac_{N}=
        // URL front:  ?subcats= → API: subcats=     (só category)
        // URL front:  ?ordem=   → API: sort=        (localStorage é só fallback, ver abaixo)
        _buildFilterParams(urlParams, includeSubcats = false) {
            const p = {};

            // "ordem" vem da URL igual aos outros filtros — precisa bater com o que o SSR
            // (layout-server-render.service.ts:buildCategoryFilterParams) já usou pra montar a
            // página, senão o client re-busca com um sort diferente do que está na tela.
            // localStorage só entra como fallback (ex.: chamada antes do
            // wsapi3-category-filter.js:applyRememberedOrder() redirecionar a URL).
            try {
                const ordem = urlParams.get('ordem') || '';
                if (ordem) {
                    p.sort = ordem;
                } else {
                    const q = urlParams.get('q') || urlParams.get('s') || '';
                    const catId = window.__WS_SERVER_DATA__?.page?.resourceId
                        || document.querySelector('#HD_CAT_ID')?.value || '';
                    const storageKey = q ? 'sort_search' : (catId ? `sort_${catId}` : null);
                    if (storageKey) {
                        const saved = localStorage[storageKey] || '';
                        if (saved) p.sort = saved;
                    }
                }
            } catch (_) {}

            const mf = urlParams.get('mf') || '';
            if (mf) p.man_id = mf.split(',').filter(Boolean)[0] || '';
            const pr = urlParams.get('pr') || '';
            if (pr) p.price_id = pr;
            for (const [key, value] of urlParams.entries()) {
                if (key.startsWith('cf_') && value) p[`charac_${key.slice(3)}`] = value;
            }
            if (includeSubcats) {
                const subcats = urlParams.get('subcats') || '';
                if (subcats) p.subcats = subcats;
            }
            return p;
        },

        async _get(path, params = {}) {
            const url = new URL(ApiWS.UrlApi + path, window.location.origin);
            url.searchParams.set('lv_id', ApiWS.LV);
            if (ApiWS.dashview) url.searchParams.set('LVdashview', '1');
            Object.entries(params).forEach(([k, v]) => {
                if (v !== null && v !== undefined && v !== '') url.searchParams.set(k, String(v));
            });
            return ApiWS.Calls._fetch(url.toString(), 'GET');
        },
        // extraParams = querystring extra além de lv_id/LVdashview (ex: check_limit=1
        // do /ia/search) — mantém TODO POST passando por aqui com o mesmo lv_id
        // que o resto da API já manda; ver Calls.ia.* mais abaixo, que antes
        // montava a URL na mão e saía sem lv_id (suspeito do 403 em produção).
        async _post(path, body = {}, extraParams = {}) {
            const url = new URL(ApiWS.UrlApi + path, window.location.origin);
            url.searchParams.set('lv_id', ApiWS.LV);
            if (ApiWS.dashview) url.searchParams.set('LVdashview', '1');
            Object.entries(extraParams).forEach(([k, v]) => {
                if (v !== null && v !== undefined && v !== '') url.searchParams.set(k, String(v));
            });
            // Alguns endpoints (ex: /user/access/forgot-password e o resto de /user/access/*)
            // exigem lv_id também no corpo do POST, não só na query string — sem isso respondem
            // "lv_id is required." mesmo com ?lv_id= presente na URL (confirmado testando direto).
            // Vai sempre por último no spread pra nunca ser sobrescrito por um "lv_id" que o
            // chamador porventura já tenha no body.
            return ApiWS.Calls._fetch(url.toString(), 'POST', { ...body, lv_id: ApiWS.LV });
        },
        async _fetch(uri, method = 'GET', body = null, extraHeaders = {}) {
            let rawJson = null;
            let httpStatus = null;
            try {
                const options = { method };
                const headers = { ...extraHeaders };
                if (body) { headers['Content-Type'] = 'application/json'; options.body = JSON.stringify(body); }
                if (Object.keys(headers).length) options.headers = headers;
                const response = await fetch(uri, options);
                httpStatus = response.status;
                try { rawJson = await response.json(); } catch (parseErr) { rawJson = null; }
                if (!response.ok) {
                    // Sempre loga (mesmo sem ApiWS.debug) para diagnosticar respostas de erro da API (ex: 409 de cart_token expirado).
                    // O corpo pode nem ser um objeto (ex: IIS às vezes devolve só uma string tipo "...conflict.")
                    console.error(`[ApiWS] ${method} ${uri} → HTTP ${response.status}`, rawJson);
                }
            } catch (err) { console.error(`[ApiWS] ${method} ${uri}`, err); }

            // Normaliza para objeto: respostas de erro do upstream nem sempre vêm como { result: 'error', ... } —
            // às vezes é só uma string (ou nulo/parse falhou). Sem isso, __httpStatus nunca era anexado e a
            // detecção de cart_token inválido (_isCartTokenInvalid) nunca disparava.
            const isErrorStatus = typeof httpStatus === 'number' && httpStatus >= 400;
            const isPlainObject = rawJson !== null && typeof rawJson === 'object' && !Array.isArray(rawJson);
            const json = isPlainObject
                ? rawJson
                : {
                    result: isErrorStatus || rawJson === null ? 'error' : undefined,
                    message: typeof rawJson === 'string' ? rawJson : undefined,
                    __raw: rawJson,
                };
            json.__httpStatus = httpStatus;
            ApiWS.logs.restCalls.push({ url: uri, method, status: httpStatus, response: json });
            if (ApiWS.debug) {
                console.groupCollapsed(`%c[ApiWS] ${method} ${uri}`, 'color:#0a84ff;font-weight:bold');
                if (body !== null) console.log('%c⬆ Enviado', 'color:#ff9500;font-weight:bold', body);
                console.log('%c⬇ Retorno', 'color:#30d158;font-weight:bold', json);
                console.groupEnd();
            }
            return json;
        },

        // ----------------------------------------------------------------
        // Normalizadores — API v3 ? formato legado consumido pelos módulos
        // ----------------------------------------------------------------
        normalize: {

            // /store/info ? ws-info-lojas.js
            // v3: institutional_menu[]{id,title,url} | contacts{tax_id,legal_name,emails[],phones[],business_hours,contact_page}
            //     address{zipcode,street,number,complement,neighborhood,city,state} | social_links[]{network,url}
            //     payment_methods[]{id} | conditions[]{id,title,subtitle,icon,url} | seo{} | store{}
            // legado: dadoscontato{fone_1,fone_3,email_1,horario,cnpj,razao,endereco,numero,cep,bairro,cidade,uf}
            //         redes_sociais{} | menuinstitucional[]{id,titulo,url} | links{faleconosco}
            //         estrutura{bandeiras_pagamento,modo} | condicoes[]{icone,titulo,subtitulo,url}
            storeInfo(r) {
                if (r?.dadoscontato) return r; // já é legado

                const phones = r.contacts?.phones || [];
                const emails = r.contacts?.emails || [];

                // phones e emails podem ser strings simples ou objetos {number}/{address}
                const getPhone = p => (typeof p === 'string' ? p : p?.number) || '';
                const getEmail = e => (typeof e === 'string' ? e : e?.address) || '';

                const social = {};
                const socialLinks = r.social_links || [];
                if (Array.isArray(socialLinks)) {
                    socialLinks.forEach(s => { social[s.network?.toLowerCase()] = s.url; });
                } else if (typeof socialLinks === 'object') {
                    Object.entries(socialLinks).forEach(([network, url]) => { social[network.toLowerCase()] = url; });
                }

                // payment_flags vem em layout.payment_flags (string) ou payment_methods[] (legado)
                const payBadges = r.layout?.payment_flags ||
                    (r.payment_methods || []).map(p => p.id).join('|');

                return {
                    // ── campos v3 preservados para uso direto pelos módulos ──
                    store_id: r.store_id || null,
                    domain: r.domain || '',
                    cashback: r.cashback || false,
                    how_did_you_find_us: r.how_did_you_find_us || [],
                    layout: r.layout || {},
                    links_loja: r.links || {},
                    search: r.search || {},
                    // ── formato legado esperado pelos módulos de tema ──
                    dadoscontato: {
                        fone_1: getPhone(phones[0]),
                        fone_2: getPhone(phones[1]),
                        fone_3: r.contacts?.whatsapp || getPhone(phones[2]),
                        email_1: getEmail(emails[0]),
                        email_2: getEmail(emails[1]),
                        horario: r.contacts?.business_hours || '',
                        cnpj: r.contacts?.tax_id || '',
                        razao: r.contacts?.legal_name || '',
                        formularios: r.contacts?.contact_forms || [],
                        endereco: r.address?.street || '',
                        numero: r.address?.number || '',
                        compl: r.address?.complement || '',
                        bairro: r.address?.neighborhood || '',
                        cidade: r.address?.city || '',
                        uf: r.address?.state || '',
                        cep: r.address?.zipcode || '',
                    },
                    redes_sociais: social,
                    menuinstitucional: (r.institutional_menu || []).map(i => ({
                        id: i.id,
                        titulo: i.title,
                        tipo: i.type || '',
                        url: i.url || 'javascript:;'
                    })),
                    links: {
                        faleconosco: r.contacts?.contact_page || '',
                        // links v3 disponíveis sem quebrar o acesso legado a links.faleconosco
                        ...(r.links || {})
                    },
                    estrutura: {
                        // layout.payment_flags é a fonte correta na v3
                        bandeiras_pagamento: payBadges,
                        // layout.mode substitui store.sales_mode da v3
                        modo: r.layout?.mode || r.store?.sales_mode || '1'
                    },
                    condicoes: (r.conditions || []).map(c => ({
                        id: c.id || 0,
                        icone: c.icon || '',
                        titulo: c.title || '',
                        subtitulo: c.subtitle || '',
                        url: c.url || '',
                        tipo: c.type || ''
                    })),
                    seo: r.seo || {}
                };
            },

            // /store/brand/list ? ws-manufacturers.js
            // v3: records[]{id, name, url, logo}
            // legado: fabricantes[]{id, nome, url, logotipo}
            brands(r) {
                if (r?.fabricantes) return r;
                return {
                    fabricantes: (r.records || []).map(b => ({
                        id: b.id,
                        nome: b.name || '',
                        url: b.url || '',
                        logotipo: b.logo || ''
                    }))
                };
            },

            // /store/category/list ? ws-categories.js
            // v3: categories[]{id, name, url, is_current, featured_product{id,name,url,image}, children[]}
            // legado: Categorias[]{id, nome, url, atual, produtodestaque{nome,url,imagem}, subcategorias[]}
            // tipo/registro são exclusivos de itens do MenuPersonalizado — não devem aparecer em categorias reais
            categories(r) {
                if (r?.Categorias) return r;
                function mapCat(c) {
                    return {
                        id: c.id,
                        nome: c.name || '',
                        url: c.url || '',
                        atual: c.is_current || false,
                        produtodestaque: c.featured_product ? {
                            nome: c.featured_product.name || '',
                            url: c.featured_product.url || '',
                            imagem: c.featured_product.image || ''
                        } : null,
                        subcategorias: (c.children || []).map(mapCat)
                    };
                }
                return {
                    Categorias: (r.categories || []).map(mapCat),
                    MenuPersonalizado: (r.custom_menu || [])
                };
            },

            // /store/category/filters ? ws-category-filter.js 2.0
            // v3: { result, store_id, category_id, records: [{type, title, id?, options:[{id,name,...}]}] }
            // pass-through — active state computed from URL by ws-category-filter
            categoryFilters(r) {
                if (!r) return { records: [], total_records: 0 };
                return r;
            },

            // produto único — usado por product/list e product/view
            // product/list  → images: { primary: url, list?: [url] }
            // product/view  → images: [{ thumb, normal, zoom }]   ← array de objetos
            // fotos legado  → sempre [{ thumb, normal, zoom }]
            product(p) {
                if (p?.codigo !== undefined) return p; // já é legado
                const prices = p.prices || {};
                const imgs = p.images || {};
                const mfr = p.manufacturer || {};
                const qty = p.quantity || {};

                // fotos:
                //   product/view → images é array [{thumb,normal,zoom}] → mantém objetos (ws-pag-prod-rules)
                //   product/list → images é objeto {primary, primary_small, primary_medium,
                //                  secundary, secundary_small, secundary_medium, list?}
                //                  → array de strings (ws-prod-list)
                // createProd() (wsapi3-prod-template-rules.js) assume que fotos[i] já vem em
                // tamanho PEQUENO (troca de prefixo "PEQ_" -> configs.imageSize+"_", nunca troca
                // a partir do tamanho original) — usar "imgs.primary" aqui (sem sufixo _small)
                // deixava esse replace() um no-op (não existe "PEQ_" pra trocar dentro do nome de
                // arquivo original), e a listagem sempre exibia a foto no tamanho cheio,
                // independente do imageSize configurado no tema. fotos[1] (secundary_small) é o
                // que ativa a troca de foto no hover em createProd() — sem ela nunca havia 2ª foto.
                let fotos;
                if (Array.isArray(imgs)) {
                    fotos = imgs; // product/view: objetos {thumb, normal, zoom}
                } else if (imgs.list?.length) {
                    fotos = imgs.list;
                } else {
                    const primary = imgs.primary_small || imgs.primary || '';
                    const secundary = imgs.secundary_small || imgs.secundary || '';
                    fotos = [primary, secundary].filter(Boolean);
                }

                return {
                    id: p.id,
                    codigo: p.sku || '',
                    nome: p.name || '',
                    breve: p.short_description || '',
                    disponivel: p.available !== false,
                    lancamento: p.is_new_release || false,
                    fretegratis: p.free_shipping || false,
                    subprodutos: p.has_variations || false,
                    variation_exibition_type: p.variation_exibition_type || '1',
                    entrega: p.has_delivery !== false,
                    tags: p.tags || [],
                    qtdminima: qty.min || 1,
                    quantidade_minima: qty.min || 0,
                    quantidade_minima_b2b: qty.min_b2b || 0,
                    quantidade_embalagem: qty.package || 0,
                    prazo: p.delivery_time_days || 0,
                    prevenda_data: p.pre_sale_date || null,
                    qtd_disponivel: p.stock || 0,
                    largura: p.package?.width || 0,
                    altura: p.package?.height || 0,
                    comprimento: p.package?.length || 0,
                    peso: p.package?.weight || 0,
                    ncm: p.tax_info?.ncm || null,
                    video: p.video_url || '',
                    fotos,
                    links: { ver_produto: p.url || '' },
                    fabricante: {
                        id: mfr.id || '',
                        nome: mfr.name || '',
                        url: mfr.url || '',
                        logotipo: mfr.logo || ''
                    },
                    precos: prices.visible === false ? null : {
                        preco: prices.regular || 0,
                        preco_promocao: prices.promotional || 0,
                        max_parcelas: prices.max_installments || 0,
                        juros: prices.installment_interest_percent || 0,
                        juros_inicia: prices.installment_interest_start || 0,
                        valor_min_parcelas: prices.min_installment_value || 0,
                        desconto_avista: prices.pix_discount || 0,
                        preco_promocao_validade: prices.promotion_ends_at || null,
                        desconto_progressivo: p.progressive_discount || []
                    },
                    // wsapi3-pag-prod-rules.js (warranty subFunction) lê infoProduto.garantia_meses
                    // (número plano de meses) — API v3 manda { type, value } ("year"/"month").
                    garantia_meses: p.guarantee
                        ? (p.guarantee.type === 'year' ? (p.guarantee.value || 0) * 12 : (p.guarantee.value || 0))
                        : 0,
                    variacoes: (p.variations || []).map(v => ({
                        id: v.id,
                        codigo: v.sku || '',
                        label: v.label || '',
                        disponivel: v.available !== false,
                        estoque: v.stock || 0,
                        imagem: v.image || '',
                        atributos: (v.attributes || []).map(a => ({ tipo: a.type || '', valor: a.value || '' })),
                        precos: v.prices ? {
                            preco: v.prices.regular || 0,
                            preco_promocao: v.prices.promotional || 0,
                            desconto_avista: v.prices.pix_discount || 0
                        } : null
                    })),
                    integracoes: (p.integrations || []).map(i => ({
                        tipo: i.type || '',
                        conteudo: i.content || ''
                    })),
                    // /product/view: cada componente do kit agora traz has_variations + variations
                    // (mesmo shape da grade do produto principal). Normaliza p/ o formato pt-br
                    // que wsapi3-pag-prod-rules.createKits() consome.
                    kit: (p.kit || []).map(k => ({
                        id: k.id,
                        codigo: k.sku || '',
                        nome: k.name || '',
                        quantidade: k.quantity || 1,
                        desconto_percentual: k.discount_percent || 0,
                        imagem: k.image || '',
                        precos: k.prices ? {
                            preco: k.prices.regular || 0,
                            preco_promocao: k.prices.promotional || 0,
                            desconto_avista: k.prices.pix_discount || 0
                        } : null,
                        has_variations: k.has_variations || false,
                        variacoes: (k.variations || []).map(v => ({
                            id: v.id,
                            codigo: v.sku || '',
                            label: v.label || '',
                            disponivel: v.available !== false,
                            estoque: v.stock || 0,
                            imagem: v.image || '',
                            prazo: v.delivery_time_days || 0,
                            atributos: (v.attributes || []).map(a => ({ tipo: a.type || '', valor: a.value || '' })),
                            precos: v.prices ? {
                                preco: v.prices.regular || 0,
                                preco_promocao: v.prices.promotional || 0,
                                desconto_avista: v.prices.pix_discount || 0
                            } : null
                        }))
                    })),
                    // wsapi3-pag-prod-rules.js (cashbackSection) lê infoProduto.cashback.valor —
                    // shape legado (valor/validade), API v3 manda { value, expires_at }.
                    cashback: p.cashback ? {
                        valor: p.cashback.value || 0,
                        validade: p.cashback.expires_at || '',
                        log: ''
                    } : false,
                    // Campos exclusivos de product/view (undefined em product/list — sem impacto nos módulos de listagem)
                    descricoes: p.descriptions?.map(d => ({
                        titulo: d.title || '',
                        conteudo: (d.content || '').replace(/^<!##HTML##>\n?/, '')
                    })),
                    migalha: p.breadcrumb ? [
                        { nome: 'Página inicial', url: '/', atual: false },
                        ...p.breadcrumb.filter(b => !b.current).map(b => ({ nome: b.name || '', url: b.url || '', atual: false }))
                    ] : undefined,
                    relacionados: p.related_products?.map(r => ({ id: r.id, nome: r.name || '', url: r.url || '', imagem: r.image || '' })),
                    caracteristicas: p.characteristics?.map(c => ({ tipo: c.type || '', tipo_id: c.type_id, valor: c.value || '', valor_id: c.value_id })),
                    compre_junto: p.buy_together || [],
                    add_fields: p.add_fields || []
                };
            },

            // /product/list (flat sources: home, category, search, recommended, recently-viewed)
            // v3: { records: [produto...], total_records, current_page, ... }
            // legado: { produtos: [prod_legado...], totalitens, paginaatual }
            productList(r) {
                if (r?.produtos) return r;
                return {
                    produtos: (r.records || []).map(ApiWS.Calls.normalize.product),
                    totalitens: r.total_records || 0,
                    paginaatual: r.current_page || 1,
                    totalpaginas: Math.ceil((r.total_records || 0) / (r.records_per_page || 24))
                };
            },

            // /product/list source=group
            // v3: { records: [{id, name, sort_order, products:[produto...]}] }
            // legado: { grupos: [{codigo, nome, url, produtos:[prod_legado...]}] }
            productGroups(r) {
                if (r?.grupos) return r;
                return {
                    grupos: (r.records || []).map(g => ({
                        codigo: g.id,
                        nome: g.name || '',
                        url: g.url || '',
                        produtos: (g.products || []).map(ApiWS.Calls.normalize.product)
                    }))
                };
            },

            // /store/additional-pages/view ? ws-pag-institutional.js
            // v3: { record: {id, title, slug, url, description} }
            // legado usado diretamente no módulo via DOM — pass-through
            institutionalPage(r) {
                if (r?.titulo) return r;
                const rec = r.record || {};
                return {
                    id: rec.id,
                    titulo: rec.title || '',
                    conteudo: rec.description || '',
                    url: rec.url || '',
                    slug: rec.slug || ''
                };
            },

            // ws-newsletter notifica por returnJson.status e returnJson.mensagem
            // v3: { result: 'success'|'error', message: '' }
            // legado: { status: '200'|'500', mensagem: '' }
            newsletter(r) {
                if (r?.mensagem) return r;
                return {
                    status: r.result === 'success' ? '200' : '500',
                    mensagem: r.message || ''
                };
            },

            // /product/variation/select → formato legado consumido por update()
            variationSelect(r) {
                if (!r || r.result !== 'success') return null;
                const rec = r.record || {};
                const prices = rec.prices || {};
                const qty = rec.quantity || {};
                return {
                    id: rec.id,
                    codigo: rec.sku || '',
                    disponivel: rec.available !== false,
                    prazo: rec.delivery_time_days || 0,
                    qtd_disponivel: rec.stock || 0,
                    quantidade_minima: qty.min || 0,
                    fotos: Array.isArray(rec.images) ? rec.images : [],
                    precos: {
                        preco: prices.regular || 0,
                        preco_promocao: prices.promotional || 0,
                    },
                    descricoes: (rec.descriptions || []).map(d => ({
                        titulo: d.title || '',
                        conteudo: (d.content || '').replace(/^<!##HTML##>\n?/, '')
                    })),
                };
            }
        },

        // ----------------------------------------------------------------
        // Chamadas
        // ----------------------------------------------------------------
        listProducts: {
            async home() {
                const serverHomeProds = window.__WS_SERVER_DATA__?.products?.home;
                let raw;
                if (serverHomeProds?.records) {
                    raw = serverHomeProds;
                } else if (typeof produtosHome != 'undefined') {
                    raw = produtosHome;
                } else {
                    raw = await ApiWS.Calls._get('/product/list', { source: 'home' });
                }
                const data = ApiWS.Calls.normalize.productList(raw);
                wsMain.setGlobalData('listHomeProds', data);
                return data;
            },
            async previous() {
                const ids = localStorage.getItem('lastProds' + ApiWS.LV);
                if (!ids?.trim()) return;
                const data = ApiWS.Calls.normalize.productList(
                    await ApiWS.Calls._get('/product/list', { source: 'recently-viewed', ids })
                );
                wsMain.setGlobalData('listLastProds', data);
                return data;
            },
            async related() {
                const productId = window.__WS_SERVER_DATA__?.page?.resourceId || document.querySelector('#LV_HD_PROD_ID')?.value;
                if (!productId) return;
                const data = ApiWS.Calls.normalize.productList(
                    await ApiWS.Calls._get('/product/list', { source: 'recommended', product_id: productId })
                );
                wsMain.setGlobalData('listRelatedProds', data?.produtos);
                return data?.produtos;
            },
            async suggestion() {
                const cartProds = window.cartJson?.products;
                if (!Array.isArray(cartProds) || !cartProds.length) return [];
                const ids = cartProds
                    .filter(p => !p.storeGift)
                    .map(p => p.productId)
                    .filter(Boolean)
                    .join(',');
                if (!ids) return [];
                const data = ApiWS.Calls.normalize.productList(
                    await ApiWS.Calls._get('/product/list', { source: 'recommended', product_id: ids })
                );
                wsMain.setGlobalData('listSuggestionProds', data?.produtos);
                return data?.produtos;
            },
            async group(params = {}) {
                const serverGroupProds = window.__WS_SERVER_DATA__?.products?.group;
                let raw;
                if (serverGroupProds?.records) {
                    raw = serverGroupProds;
                } else if (typeof produtosGrupo != 'undefined') {
                    raw = produtosGrupo;
                } else {
                    raw = await ApiWS.Calls._get('/product/list', { source: 'group', ...params });
                }
                const data = ApiWS.Calls.normalize.productGroups(raw);
                wsMain.setGlobalData('listGroupProds', data);
                return data;
            },
            async category(prodsPerlineVar, page = false) {
                // Página de fabricante: mesma âncora/etapa da categoria, só muda a origem —
                // /product/list?source=manufacturer&manufacturer_id={id}. O sinal vem do
                // /url/resolve (resource.url_type "FABR") propagado em __WS_SERVER_DATA__.page.urlType
                // pelo SSR (layout-server-render.service.ts), que faz a mesma bifurcação.
                const isManufacturerPage = window.__WS_SERVER_DATA__?.page?.urlType === 'FABR';
                const categoryId = window.__WS_SERVER_DATA__?.page?.resourceId || document.querySelector('#HD_CAT_ID')?.value || '';
                const urlParams = new URL(window.location).searchParams;
                const q = urlParams.get('q') || urlParams.get('s') || '';

                // Search mode: tem termo de busca mas não tem categoria — delega para search()
                if (q && !categoryId) {
                    // Repassa a página: o scroll infinito chama category(perLine, page + 1) e, sem
                    // isso, search() cai no "?pagina=" da URL (ausente → 1) e repete a página 1.
                    return ApiWS.Calls.listProducts.search(page);
                }

                // wsapi3-category-filter.js:switchPage() navega pra "?pagina=N" (recarga cheia da
                // página, não AJAX) — "pagina" é o nome real usado nos links; "page" fica como
                // fallback caso algum outro fluxo use o nome em inglês.
                const currentPage = page || urlParams.get('pagina') || urlParams.get('page') || 1;

                // SSR já buscou a página 1 sem filtro/busca/ordenação — nesses casos reaproveita
                // (mesmo padrão de listProducts.group/home) em vez de refazer a mesma chamada.
                const serverCategoryProds = window.__WS_SERVER_DATA__?.products?.category;
                const canReuseServerData = serverCategoryProds?.records
                    && !q && Number(currentPage) === 1 && urlParams.toString() === '';

                let raw;
                if (canReuseServerData) {
                    raw = serverCategoryProds;
                } else {
                    const params = isManufacturerPage
                        ? {
                            source: 'manufacturer',
                            manufacturer_id: categoryId,
                            page: currentPage,
                            ...ApiWS.Calls._buildFilterParams(urlParams, true),
                        }
                        : {
                            source: 'category',
                            category_id: categoryId,
                            page: currentPage,
                            ...ApiWS.Calls._buildFilterParams(urlParams, true),
                        };
                    if (q && !isManufacturerPage) params.q = q;
                    raw = await ApiWS.Calls._get('/product/list', params);
                }
                const data = ApiWS.Calls.normalize.productList(raw);
                // normalize.productList() descarta "record" (não existe na v2/legado, que os outros
                // sources também usam) — mas pra source=category é onde vem {id, name} da categoria
                // sendo listada (equivalente ao último item de "migalha" na v2, que a v3 não retorna
                // mais). Anexado aqui, específico de category() — não em normalize.productList()
                // porque "record" pode significar outra coisa (ou nada) pros demais sources
                // (home/search/recommended/recently-viewed) que reaproveitam a mesma função. Ver
                // customBreadcrumb() em custom-listagem.js, que lê daqui pro título no topo da listagem.
                data.categoria = raw?.record ? { id: raw.record.id, nome: raw.record.name || '' } : null;
                wsMain.setGlobalData('listCategoryProds', data);
                return data;
            },
            async search(pageArg = false) {
                const urlParams = new URL(window.location).searchParams;
                const q = urlParams.get('q') || urlParams.get('s') || '';
                const page = pageArg || urlParams.get('pagina') || urlParams.get('page') || 1;
                if (!q) return;
                const params = {
                    source: 'search',
                    q,
                    page,
                    ...ApiWS.Calls._buildFilterParams(urlParams, false),
                };
                const data = ApiWS.Calls.normalize.productList(
                    await ApiWS.Calls._get('/product/list', params)
                );
                wsMain.setGlobalData('listCategoryProds', data);
                return data;
            },
            // Igual a search(), mas recebe o termo direto (não lê da URL) — usado
            // por módulos que constroem a busca a partir de outra fonte (ex:
            // wsapi3-personal-shopper.js, que monta `q` a partir do histórico de
            // navegação ou das keywords devolvidas por Calls.ia.search()).
            async byQuery(q) {
                if (!q) return null;
                // search_mode=or: busca da IA usa várias palavras/keywords soltas
                // (ex: "blusa-gola-alta") — precisa casar qualquer uma delas, não
                // a frase inteira (comportamento padrão da busca normal do site).
                return ApiWS.Calls.normalize.productList(
                    await ApiWS.Calls._get('/product/list', { source: 'search', q, search_mode: 'or' })
                );
            }
        },

        // ----------------------------------------------------------------
        // IA / Personal Shopper (/ia/search) — usado por wsapi3-personal-shopper.js
        // ----------------------------------------------------------------
        ia: {
            // ?check_limit=1 só verifica se a loja pode usar o app (sem gastar
            // uma consulta de fato) — { result, message, available }.
            async checkAvailable() {
                return ApiWS.Calls._post('/ia/search', {
                    store_id: Number(ApiWS.LV) || ApiWS.LV,
                }, { check_limit: 1 });
            },
            // history = turnos anteriores [{role:'user'|'assistant', content}],
            // sem incluir o `query` atual (ele vai à parte no corpo). Retorno:
            // { result, reply, keywords[], records[], ... }.
            async search(query, history = []) {
                return ApiWS.Calls._post('/ia/search', {
                    store_id: Number(ApiWS.LV) || ApiWS.LV,
                    query,
                    history,
                });
            },
        },

        async produto() {
            const productId = window.__WS_SERVER_DATA__?.page?.resourceId || document.querySelector('#LV_HD_PROD_ID')?.value;
            const serverProduct = window.__WS_SERVER_DATA__?.product;
            const raw = serverProduct?.record
                ? serverProduct
                : await ApiWS.Calls._get('/product/view', { id: productId });
            // /product/view retorna { record: {...} }
            let record = raw.record || raw;
            const crumbs = Array.isArray(record.breadcrumb) ? record.breadcrumb : [];
            if (!crumbs.length || crumbs.some(crumb => !crumb.current && !crumb.url)) {
                const categories = Array.isArray(record.categories) ? record.categories : [];
                const primary = categories.find(category => category.is_primary) || categories[0];
                const categoryId = primary && (primary.subcategory_id || primary.category_id || primary.section_id || primary.department_id);
                if (categoryId) {
                    try {
                        const tree = window.__WS_SERVER_DATA__?.categorias
                            || (typeof categoriesHome !== 'undefined' ? categoriesHome : null)
                            || await ApiWS.Calls._get('/store/category/list');
                        const findPath = (nodes) => {
                            for (const node of nodes || []) {
                                if (String(node.id) === String(categoryId)) return [node];
                                const path = findPath(node.children);
                                if (path) return [node, ...path];
                            }
                            return null;
                        };
                        const path = findPath(tree.categories);
                        if (path) {
                            record = { ...record, breadcrumb: [
                                ...path.map(node => ({ name: node.name, url: node.url, current: false })),
                                ...(record.name ? [{ name: record.name, url: record.url, current: true }] : [])
                            ] };
                        }
                    } catch (error) {
                        console.warn('[ApiWS] Falha ao resolver links da migalha:', error.message);
                    }
                }
            }
            const data = ApiWS.Calls.normalize.product(record);
            wsMain.setGlobalData('infoProduto', data);
            return data;
        },

        async categoryFilters() {
            // Página de fabricante: não há endpoint de "filtros por marca" isolado (as facetas
            // dependem de category_id). Sem categoria, não há o que buscar — devolve vazio pra
            // o category-filter.js não ficar esperando infoFilters pra sempre. (O resourceId
            // aqui seria o id da marca; usá-lo como category_id traria filtros errados.)
            if (window.__WS_SERVER_DATA__?.page?.urlType === 'FABR') {
                const empty = { records: [], total_records: 0 };
                wsMain.setGlobalData('infoFilters', empty);
                return empty;
            }
            const categoryId = window.__WS_SERVER_DATA__?.page?.resourceId
                || document.querySelector('#HD_CAT_ID')?.value
                || '';
            if (!categoryId) {
                const empty = { records: [], total_records: 0 };
                wsMain.setGlobalData('infoFilters', empty);
                return empty;
            }
            const serverFilters = window.__WS_SERVER_DATA__?.filters;
            const raw = serverFilters?.records
                ? serverFilters
                : await ApiWS.Calls._get('/store/category/filters', { category_id: categoryId });
            const data = ApiWS.Calls.normalize.categoryFilters(raw);
            wsMain.setGlobalData('infoFilters', data);
            return data;
        },

        async infosLojas() {
            const serverStoreInfo = window.__WS_SERVER_DATA__?.storeInfo;
            let raw;
            if (serverStoreInfo?.store_id) {
                raw = serverStoreInfo;
            } else if (typeof infolojasHome != 'undefined') {
                raw = infolojasHome;
            } else {
                raw = await ApiWS.Calls._get('/store/info');
            }
            const data = ApiWS.Calls.normalize.storeInfo(raw);
            wsMain.setGlobalData('infoLoja', data);
            return data;
        },

        async manufactures() {
            const serverManufacturer = window.__WS_SERVER_DATA__?.manufacturer;
            let raw;
            if (serverManufacturer?.records) {
                raw = serverManufacturer;
            } else if (typeof fabricantesHome != 'undefined') {
                raw = fabricantesHome;
            } else {
                raw = await ApiWS.Calls._get('/store/brand/list');
            }
            const data = ApiWS.Calls.normalize.brands(raw);
            wsMain.setGlobalData('infoManufactureres', data);
            return data;
        },

        async ListaCategorias() {
            const categoryId = document.querySelector('#HD_CAT_ID')?.value || '';
            const serverCategorias = window.__WS_SERVER_DATA__?.categorias;
            let raw;
            if (serverCategorias?.categories) {
                raw = serverCategorias;
            } else if (typeof categoriesHome != 'undefined') {
                raw = categoriesHome;
            } else {
                raw = await ApiWS.Calls._get('/store/category/list', { category_id: categoryId });
            }
            const data = ApiWS.Calls.normalize.categories(raw);
            wsMain.setGlobalData('infoCategory', data);
            return data;
        },

        async institutional(pageId) {
            const raw = await ApiWS.Calls._get('/store/additional-pages/view', { id: pageId });
            const data = ApiWS.Calls.normalize.institutionalPage(raw);
            wsMain.setGlobalData('infoProduto', data);
            return data;
        },

        async banners() {
            const pageType = document.querySelector('#HdEtapaLoja')?.value?.toLowerCase() || 'home';
            const serverBanners = window.__WS_SERVER_DATA__?.banners;
            let raw;
            if (serverBanners?.records) {
                raw = serverBanners;
            } else if (typeof bannersHome != 'undefined') {
                raw = bannersHome;
            } else {
                // A API de banners filtra por dispositivo; sem `device` ela analisa o User-Agent
                // e assume desktop quando não reconhece (sumindo com os banners de mobile).
                // Mesmo sinal que o wsapi3-banners.js usa pra decidir M/D no filtro local.
                const device = document.querySelector('#HD_VRS_MOBILE')?.value?.toLowerCase() === 'true' ? 'mobile' : 'desktop';
                raw = await ApiWS.Calls._get('/store/banner/list', { page_type: pageType, device });
            }
            const data = ApiWS.Calls.normalize.banners(raw);
            wsMain.setGlobalData('infoBanners', data);
            return data;
        },

        normalize_banners_alias: null, // alias abaixo para manter coerência de namespace
        normalizeBannersResponse(raw) { return ApiWS.Calls.normalize.banners(raw); },

        async cartStart() {
            const existing = localStorage['orderIdKeepTC_B']?.trim() || '';
            const data = await ApiWS.Calls._post('/cart/start', { cart_token: existing });
            if (data?.result === 'success' && data?.record?.cart_token) {
                localStorage['orderIdKeepTC_B'] = data.record.cart_token;
            }
            return data;
        },
        // error_code (no corpo JSON) que significam "esse cart_token não serve mais"
        // → aí sim vale rotacionar (apagar orderIdKeepTC_B e criar carrinho novo).
        // A API de /cart/{view,preview,items/add} responde SEMPRE HTTP 200 e sinaliza
        // o resultado em `error_code` (tabela completa: METHOD_NOT_ALLOWED,
        // INVALID_BODY, STORE_ID_REQUIRED, CART_TOKEN_INVALID, PRODUCT_ID_REQUIRED,
        // ORDER_ALREADY_PLACED, PRODUCT_NOT_FOUND, PRODUCT_REQUIRES_SELECTION,
        // PRODUCT_PACKAGE_MULTIPLE, INSUFFICIENT_STOCK, ORDER_INIT_FAILED,
        // INTERNAL_ERROR). Só estes dois são "token morto"; todo o resto é erro de
        // input/produto/servidor e NÃO deve descartar o carrinho.
        _cartTokenDeadCodes: ['CART_TOKEN_INVALID', 'ORDER_ALREADY_PLACED'],
        _isCartTokenInvalid(data) {
            // 1) Sinal no JSON (autoritativo). Qualquer outro error_code —
            //    inclusive INTERNAL_ERROR / ORDER_INIT_FAILED (transitórios) — NÃO
            //    invalida o carrinho.
            const code = String(data?.error_code || '').toUpperCase();
            if (code) {
                return ApiWS.Calls._cartTokenDeadCodes.includes(code);
            }

            // 2) Fallback legado só para a janela de deploy (servidor ainda no
            //    formato antigo: erro via HTTP status, sem error_code). 409/410 =
            //    token virou pedido / gone. 5xx e "Erro no proxy" (timeout do
            //    upstream) NUNCA invalidam — senão um único 500 no /cart/view
            //    descartava o cart_token bom e criava um carrinho vazio ("o
            //    carrinho não persiste ao trocar de página"). Pode sair quando a
            //    API sempre-200 estiver 100% no ar.
            const s = Number(data?.__httpStatus);
            return s === 409 || s === 410;
        },
        async _ensureCartToken() {
            if (!localStorage['orderIdKeepTC_B']?.trim()) {
                await ApiWS.Calls.cartStart();
            }
        },
        async carrinho() {
            await ApiWS.Calls._ensureCartToken();
            const orderTC = localStorage['orderIdKeepTC_B']?.trim() || '';
            const data = await ApiWS.Calls._get('/cart/preview', { cart_token: orderTC });
            if (ApiWS.Calls._isCartTokenInvalid(data)) {
                localStorage.removeItem('orderIdKeepTC_B');
                const started = await ApiWS.Calls.cartStart();
                if (started?.result === 'success') {
                    const freshToken = localStorage['orderIdKeepTC_B']?.trim() || '';
                    const retryData = await ApiWS.Calls._get('/cart/preview', { cart_token: freshToken });
                    wsMain.setGlobalData('infoCart', retryData);
                    return retryData;
                }
            }
            if (data?.error_code) return ApiWS.Calls._keepLastCart('/cart/preview', data);
            wsMain.setGlobalData('infoCart', data);
            return data;
        },

        // Erro não-fatal da API (INTERNAL_ERROR, ORDER_INIT_FAILED, STORE_ID_REQUIRED…):
        // não é token morto (senão _isCartTokenInvalid já teria rotacionado) e o corpo
        // não traz carrinho utilizável. Não sobrescreve o infoCart bom com um payload
        // vazio — devolve o último carrinho conhecido, se houver (evita o drawer
        // "piscar" pra vazio num erro transitório).
        _keepLastCart(endpoint, data) {
            console.warn(`[cart] ${endpoint} error_code: ${data.error_code}${data.message ? ' — ' + data.message : ''}`);
            return wsMain.globalData?.infoCart || data;
        },

        async cartView() {
            await ApiWS.Calls._ensureCartToken();
            const orderTC = localStorage['orderIdKeepTC_B']?.trim() || '';
            const data = await ApiWS.Calls._get('/cart/view', { cart_token: orderTC });
            if (ApiWS.Calls._isCartTokenInvalid(data)) {
                localStorage.removeItem('orderIdKeepTC_B');
                const started = await ApiWS.Calls.cartStart();
                if (started?.result === 'success') {
                    const freshToken = localStorage['orderIdKeepTC_B']?.trim() || '';
                    const retryData = await ApiWS.Calls._get('/cart/view', { cart_token: freshToken });
                    wsMain.setGlobalData('infoCart', retryData);
                    return retryData;
                }
            }
            if (data?.error_code) return ApiWS.Calls._keepLastCart('/cart/view', data);
            wsMain.setGlobalData('infoCart', data);
            return data;
        },
        async cartShippingCalculate(zipcode) {
            const orderTC = localStorage['orderIdKeepTC_B']?.trim() || '';
            const clean = String(zipcode).replace(/\D/g, '');
            return ApiWS.Calls._get('/cart/shipping/calculate', { zipcode: clean, cart_token: orderTC });
        },
        // Regras de desconto de frete cadastradas na loja (não depende de CEP/carrinho).
        // records[].min_order_value e discount_percent vêm em centavos/pontos-base
        // (ex: min_order_value:50000 = R$500,00; discount_percent:10000 = 100%).
        async cartShippingDiscounts() {
            return ApiWS.Calls._get('/cart/shipping/discounts');
        },
        async cartShippingSelect({ shippingId, shippingName, shippingPrice, shippingDiscount = 0, shippingDeadline, zipcode, scheduling = '' } = {}) {
            const cartToken = localStorage['orderIdKeepTC_B']?.trim() || '';
            return ApiWS.Calls._post('/cart/shipping/select', {
                store_id: Number(ApiWS.LV) || ApiWS.LV,
                cart_token: cartToken,
                shipping_id: String(shippingId),
                shipping_name: shippingName,
                shipping_price: Number(shippingPrice),
                shipping_discount: Number(shippingDiscount),
                shipping_deadline: Number(shippingDeadline),
                zipcode: String(zipcode).replace(/\D/g, ''),
                scheduling: scheduling || '',
            });
        },
        async cartAddItem({ productId, quantity = 1, variationValues = [], kitVariations = [], additionalFields = [], isGift = false } = {}) {
            await ApiWS.Calls._ensureCartToken();
            const cartToken = localStorage['orderIdKeepTC_B']?.trim() || '';
            const body = { store_id: Number(ApiWS.LV) || ApiWS.LV, cart_token: cartToken, product_id: productId, quantity, is_gift: isGift };
            if (variationValues.length) body.variation_values = variationValues;
            if (kitVariations.length) body.kit_variations = kitVariations;
            if (additionalFields.length) body.additional_fields = additionalFields;
            ApiWS.Origin.capture(); // fallback caso ApiStart não tenha rodado
            const origin = ApiWS.Origin.get();
            if (origin) body.origin = origin;
            let data = await ApiWS.Calls._post('/cart/items/add', body);
            if (ApiWS.Calls._isCartTokenInvalid(data)) {
                // cart_token preso a um pedido já finalizado (ex: 409) — inicia carrinho novo e tenta de novo
                localStorage.removeItem('orderIdKeepTC_B');
                const started = await ApiWS.Calls.cartStart();
                if (started?.result === 'success') {
                    body.cart_token = localStorage['orderIdKeepTC_B']?.trim() || '';
                    data = await ApiWS.Calls._post('/cart/items/add', body);
                }
            }
            if (data?.result === 'success' && data?.record?.cart_token) {
                localStorage['orderIdKeepTC_B'] = data.record.cart_token;
            }
            return data;
        },
        async cartItemUpdate({ itemId, quantity } = {}) {
            const cartToken = localStorage['orderIdKeepTC_B']?.trim() || '';
            return ApiWS.Calls._post('/cart/items/update', {
                store_id: Number(ApiWS.LV) || ApiWS.LV,
                cart_token: cartToken,
                item_id: itemId,
                quantity,
            });
        },
        async cartItemRemove({ itemId, groupId = '' } = {}) {
            const cartToken = localStorage['orderIdKeepTC_B']?.trim() || '';
            return ApiWS.Calls._post('/cart/items/remove', {
                store_id: Number(ApiWS.LV) || ApiWS.LV,
                cart_token: cartToken,
                item_id: itemId,
                group_id: groupId,
            });
        },
        async cartCouponApply(couponCode) {
            const cartToken = localStorage['orderIdKeepTC_B']?.trim() || '';
            return ApiWS.Calls._post('/cart/coupon/apply', {
                store_id: Number(ApiWS.LV) || ApiWS.LV,
                cart_token: cartToken,
                coupon_code: couponCode,
            });
        },
        async cartCouponRemove() {
            const cartToken = localStorage['orderIdKeepTC_B']?.trim() || '';
            return ApiWS.Calls._post('/cart/coupon/remove', {
                store_id: Number(ApiWS.LV) || ApiWS.LV,
                cart_token: cartToken,
            });
        },
        async cartClose({ shippingOnCheckout = false } = {}) {
            const cartToken = localStorage['orderIdKeepTC_B']?.trim() || '';
            // shipping_on_checkout=1 permite fechar o pedido sem frete calculado
            // ainda (usado pelo carrinho lateral, que não obriga calcular frete
            // antes de avançar) — resolvido lá dentro do próprio checkout.
            const path = shippingOnCheckout ? '/cart/close?shipping_on_checkout=1' : '/cart/close';
            return ApiWS.Calls._post(path, {
                store_id: Number(ApiWS.LV) || ApiWS.LV,
                cart_token: cartToken,
            });
        },
        async cartItemSetGiftpack({ itemId, productId, status } = {}) {
            const cartToken = localStorage['orderIdKeepTC_B']?.trim() || '';
            return ApiWS.Calls._post('/cart/items/set_giftpack', {
                store_id: Number(ApiWS.LV) || ApiWS.LV,
                cart_token: cartToken,
                item_id: Number(itemId),
                product_id: Number(productId),
                status: Boolean(status),
            });
        },
        async cartCheckoutInit(ct, ct2, orderNumber) {
            return ApiWS.Calls._get('/cart/checkout/init', {
                ct: ct,
                ct2: ct2,
                order_number: orderNumber
            });
        },
        async cartCheckoutShippingSelect({ cartToken, shippingId, shippingName, shippingPrice, shippingDiscount = 0, shippingDeadline, zipcode, scheduling = '' } = {}) {
            return ApiWS.Calls._post('/cart/shipping/select', {
                store_id: Number(ApiWS.LV) || ApiWS.LV,
                cart_token: String(cartToken || ''),
                shipping_id: String(shippingId),
                shipping_name: shippingName,
                shipping_price: Number(shippingPrice),
                shipping_discount: Number(shippingDiscount),
                shipping_deadline: Number(shippingDeadline),
                zipcode: String(zipcode).replace(/\D/g, ''),
                scheduling: scheduling || '',
            });
        },
        async cartCheckoutClose(cartToken) {
            return ApiWS.Calls._post('/cart/close', {
                store_id: Number(ApiWS.LV) || ApiWS.LV,
                cart_token: String(cartToken || ''),
            });
        },

        async cartCheckoutPayment({ ct, ct2, orderNumber, paymentMethod, orderRemarks, captchaToken, address } = {}) {
            var body = {
                ct:           String(ct || ''),
                ct2:          String(ct2 || ''),
                order_number: String(orderNumber || ''),
                payment_method: paymentMethod || {},
            };
            if (address)       body.address        = address;
            if (orderRemarks)  body.order_remarks  = orderRemarks;
            if (captchaToken)  body.captcha_token  = captchaToken;
            return ApiWS.Calls._post('/cart/checkout/payment', body);
        },

        // POST /cart/checkout/navigation — envia o histórico de navegação acumulado em
        // ApiWS.Navigation (localStorage) para a API vincular ao pedido. Best-effort: falha
        // aqui nunca deve travar o fluxo de compra, então quem chama deve engolir o erro.
        async cartCheckoutNavigation({ cartToken, customerId, customerEmail, events } = {}) {
            var body = {
                store_id:   Number(ApiWS.LV) || ApiWS.LV,
                cart_token: String(cartToken || ''),
                events:     events || [],
            };
            if (customerId)    body.customer_id    = Number(customerId);
            if (customerEmail) body.customer_email = customerEmail;
            return ApiWS.Calls._post('/cart/checkout/navigation', body);
        },

        async login(login, password) {
            // Chama NestJS /auth/login — ele seta o cookie HttpOnly ws_token
            let json = {};
            try {
                const res = await fetch('/auth/login', {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ login, password })
                });
                json = await res.json();
            } catch (e) { console.error('[ApiWS] login', e); }
            if (ApiWS.debug) {
                console.groupCollapsed('%c[ApiWS] POST /auth/login', 'color:#0a84ff;font-weight:bold');
                console.log('%c⬆ Enviado', 'color:#ff9500;font-weight:bold', { login, password: '***' });
                console.log('%c⬇ Retorno', 'color:#30d158;font-weight:bold', json);
                console.groupEnd();
            }
            return json;
        },
        async logout() {
            // Chama NestJS /auth/logout — ele invalida o cookie HttpOnly ws_token
            let json = {};
            try {
                const res = await fetch('/auth/logout', { method: 'POST', credentials: 'same-origin' });
                json = await res.json();
            } catch (e) { console.error('[ApiWS] logout', e); }
            if (ApiWS.debug) {
                console.groupCollapsed('%c[ApiWS] POST /auth/logout', 'color:#0a84ff;font-weight:bold');
                console.log('%c⬇ Retorno', 'color:#30d158;font-weight:bold', json);
                console.groupEnd();
            }
            return json;
        },
        async session() {
            // Chama NestJS /auth/me — usa o cookie HttpOnly, não lê token do localStorage
            let json = {};
            try {
                const res = await fetch('/auth/me', { credentials: 'same-origin' });
                json = await res.json();
            } catch (e) { console.error('[ApiWS] session', e); }
            if (ApiWS.debug) {
                console.groupCollapsed('%c[ApiWS] GET /auth/me', 'color:#0a84ff;font-weight:bold');
                console.log('%c⬇ Retorno', 'color:#30d158;font-weight:bold', json);
                console.groupEnd();
            }
            return json;
        },
        async forgotPassword(email) {
            return ApiWS.Calls._post('/user/access/forgot-password', { email });
        },
        async forgotPasswordVerify(email, code) {
            return ApiWS.Calls._post('/user/access/forgot-password-verify', { email, code });
        },
        async resetPassword(resetToken, newPassword) {
            return ApiWS.Calls._post('/user/access/reset-password', { reset_token: resetToken, new_password: newPassword });
        },
        async signup(body) {
            // Chama NestJS /auth/signup — seta cookie HttpOnly com o token retornado
            // Inclui domain da infoLoja para que o backend repasse o domínio correto à API
            const infoLoja = ((typeof wsMain !== 'undefined' && wsMain.globalData) || {}).infoLoja || {};
            const enrichedBody = {
                domain: infoLoja.domain || window.location.hostname,
                ...body
            };
            let json = {};
            try {
                const res = await fetch('/auth/signup', {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(enrichedBody)
                });
                json = await res.json();
            } catch (e) { console.error('[ApiWS] signup', e); }
            if (ApiWS.debug) {
                console.groupCollapsed('%c[ApiWS] POST /auth/signup', 'color:#0a84ff;font-weight:bold');
                console.log('%c⬆ Enviado', 'color:#ff9500;font-weight:bold', { ...enrichedBody, password: '***' });
                console.log('%c⬇ Retorno', 'color:#30d158;font-weight:bold', json);
                console.groupEnd();
            }
            return json;
        },
        async checkSignup(fields = {}) {
            // Passa via proxy — usa domain da infoLoja (fonte canônica) em vez do hostname do browser
            const infoLoja = ((typeof wsMain !== 'undefined' && wsMain.globalData) || {}).infoLoja || {};
            return ApiWS.Calls._post('/user/access/check-signup', {
                store_id: infoLoja.store_id || Number(ApiWS.LV) || ApiWS.LV,
                domain: infoLoja.domain || window.location.hostname,
                ...fields
            });
        },

        async CadastraNews(name, email) {
            if (!name) return { status: 500, message: 'Name is required.' };
            if (!email) return { status: 500, message: 'Email is required.' };
            const raw = await ApiWS.Calls._post('/store/newsletter/sign-up', {
                store_id: Number(ApiWS.LV) || 0,
                name,
                email,
            });
            return ApiWS.Calls.normalize.newsletter(raw);
        },

        // POST /store/contact/form-send
        // fields: [{nome, valor}] — usa os mesmos nomes que a API v3
        // options: { subject?: string, product_id?: number }
        // Retorna a resposta bruta da API: { result: 'success'|'error', message: '' }
        async contactFormSend(fields, options = {}) {
            return ApiWS.Calls._post('/store/contact/form-send', {
                store_id: Number(ApiWS.LV) || 0,
                fields: (fields || []).map(f => ({
                    nome: String(f.nome || f.name || ''),
                    valor: String(f.valor || f.value || ''),
                })),
                product_id: Number(options.product_id) || 0,
                subject: String(options.subject || ''),
            });
        },

        // POST /product/stock-notification
        // Registra e-mail para aviso de disponibilidade de produto esgotado.
        // Retorna a resposta bruta da API: { result: 'success'|'error', message: '' }
        async stockNotification(productId, email) {
            return ApiWS.Calls._post('/product/stock-notification', {
                lv_id: String(ApiWS.LV),
                product_id: String(productId),
                email: String(email),
            });
        },

        // GET /product/variation/select?lv_id=&variation_id=
        async variationSelect(variationId) {
            return ApiWS.Calls._get('/product/variation/select', { variation_id: variationId });
        },

        // GET /product/variation/filter?lv_id=&product_id=&variation_index=&selected_1=&selected_2=
        async variationFilter(productId, variationIndex, selected1, selected2) {
            const params = { product_id: productId, variation_index: variationIndex };
            if (selected1 != null && selected1 !== '') params.selected_1 = String(selected1);
            if (selected2 != null && selected2 !== '') params.selected_2 = String(selected2);
            return ApiWS.Calls._get('/product/variation/filter', params);
        }
    }
};

// ----------------------------------------------------------------
// Sessão do cliente logado
// ----------------------------------------------------------------
ApiWS.User = {
    _key: 'ws_customer_session',

    getSession() {
        try { return JSON.parse(localStorage.getItem(this._key)) || null; }
        catch { return null; }
    },

    saveSession(record) {
        try {
            // Salva apenas dados de UI — token fica no cookie HttpOnly gerenciado pelo servidor
            const { token, access_token, ...uiData } = record || {};
            localStorage.setItem(this._key, JSON.stringify(uiData));
        } catch { }
    },

    clearSession() {
        try { localStorage.removeItem(this._key); }
        catch { }
    },

    isValid() {
        // Validade real é determinada pelo cookie HttpOnly via /auth/me
        // Aqui só checa se há dados de UI salvos localmente
        const s = this.getSession();
        if (!s || !s.expires_at) return false;
        return new Date(s.expires_at) > new Date();
    },

    async validateAndSync() {
        if (!this.getSession()) return;

        try {
            const data = await ApiWS.Calls.session();
            if (!data.ok || !data.user) {
                this.clearSession();
                // e-mail conhecido continua servindo pra pré-preencher, sem trava
                if (ApiWS.CustomerEmail) ApiWS.CustomerEmail.demote();
                // Mesmo motivo do logout explícito (ver "Sair" em
                // wsapi3-customer-area-page.js): o carrinho fica associado ao
                // cliente cuja sessão acabou de ser invalidada — sem isso ele
                // sobrevive e é reaproveitado pelo próximo login/visitante
                // nesse navegador, gerando conflito de ID.
                try {
                    localStorage.removeItem('orderIdKeepTC_B');
                    await ApiWS.Calls.cartStart();
                } catch (e2) { }
                const path = window.location.pathname.replace(/\/+$/, '');
                if (path !== '/login') window.location.href = '/login';
            }
        } catch (e) {
            // Erro de rede — mantém sessão local para não deslogar offline
        }
    }
};

// ----------------------------------------------------------------
// E-mail conhecido do cliente (localStorage) — chave única alimentada por
// vários pontos: login/cadastro (authoritative: sempre sobrepõe), e, para
// visitante não logado, passo de identificação, newsletter e contato
// (só gravam se o valor atual NÃO veio de um login). No logout o valor é
// mantido para pré-preencher formulários, mas perde o "authoritative"
// (ApiWS.CustomerEmail.demote()), então o próximo login volta a mandar.
// ----------------------------------------------------------------
ApiWS.CustomerEmail = {
    _key: 'ws_customer_email',

    _read() {
        try { return JSON.parse(localStorage.getItem(this._key) || 'null'); }
        catch { return null; }
    },

    get() {
        const cur = this._read();
        return (cur && cur.value) || '';
    },

    set(email, { source = 'form', authoritative = false } = {}) {
        email = String(email || '').trim().toLowerCase();
        if (!/\S+@\S+\.\S+/.test(email)) return;
        try {
            const cur = this._read();
            // Um valor vindo de login/sessão só é substituído por outro login.
            if (!authoritative && cur && cur.authoritative) return;
            localStorage.setItem(this._key, JSON.stringify({
                value: email, source, authoritative, ts: Date.now(),
            }));
        } catch { }
    },

    // Logout: não apaga (o e-mail segue útil pra pré-preencher), só remove a
    // trava pra um novo login/identificação poder sobrescrever.
    demote() {
        try {
            const cur = this._read();
            if (cur && cur.authoritative) {
                cur.authoritative = false;
                localStorage.setItem(this._key, JSON.stringify(cur));
            }
        } catch { }
    },
};

// ----------------------------------------------------------------
// Histórico de navegação (localStorage) — acumulado página a página por
// wsapi3-main, esvaziado por wsapi3-checkout-final-page após o pedido concluído.
// ----------------------------------------------------------------
ApiWS.Navigation = {
    _key: 'ws_nav_history',

    // #HdEtapaLoja (enum do backend) → vocabulário do endpoint /cart/checkout/navigation
    _pageTypeMap: {
        HOME: 'home',
        PRODUTO: 'product',
        LISTAGEM: 'category',
        CARRINHO: 'cart',
        CHECKOUT: 'checkout',
        FORMAS_PAGAMENTO: 'payment',
        FINALPAGAMENTO: 'order_confirmation',
        LOGIN: 'login',
        CADASTRO: 'signup',
        AREA_CLIENTE: 'account',
        INSTITUCIONAL: 'institutional',
    },

    _device() {
        return /Mobi|Android/i.test(navigator.userAgent) ? 'mobile' : 'desktop';
    },

    // Horário local America/Sao_Paulo no formato "AAAA-MM-DDTHH:mm:ss" (sem timezone),
    // igual ao exemplo do contrato da API — new Date().toISOString() daria UTC, errado aqui.
    _localDatetime() {
        var parts = new Intl.DateTimeFormat('en-CA', {
            timeZone: 'America/Sao_Paulo',
            year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', second: '2-digit',
            hour12: false,
        }).formatToParts(new Date());
        var get = function (type) { return (parts.find(function (p) { return p.type === type; }) || {}).value || '00'; };
        return get('year') + '-' + get('month') + '-' + get('day') + 'T' + get('hour') + ':' + get('minute') + ':' + get('second');
    },

    // Chamado por wsapi3-main a cada carregamento de página.
    track(pageTypeRaw, pageUrl, regId) {
        try {
            var pageType = ApiWS.Navigation._pageTypeMap[String(pageTypeRaw || '').toUpperCase()] || 'other';
            var history = ApiWS.Navigation.getAll();
            history.push({
                page_type: pageType,
                page_url:  pageUrl || window.location.pathname,
                reg_id:    Number(regId) || 0,
                device:    ApiWS.Navigation._device(),
                datetime:  ApiWS.Navigation._localDatetime(),
            });
            localStorage.setItem(ApiWS.Navigation._key, JSON.stringify(history));
        } catch (e) { }
    },

    // Corrige o reg_id do último evento salvo quando ele só é conhecido depois de um
    // fetch assíncrono (ex: order_id da página final, que não está disponível no window.load).
    updateLastRegId(regId) {
        try {
            var history = ApiWS.Navigation.getAll();
            var last = history[history.length - 1];
            if (last && !last.reg_id && regId) {
                last.reg_id = Number(regId) || 0;
                localStorage.setItem(ApiWS.Navigation._key, JSON.stringify(history));
            }
        } catch (e) { }
    },

    getAll() {
        try { return JSON.parse(localStorage.getItem(ApiWS.Navigation._key)) || []; }
        catch { return []; }
    },

    clear() {
        try { localStorage.removeItem(ApiWS.Navigation._key); }
        catch { }
    }
};

// Banner normalize acessível também via Calls.normalize.banners
ApiWS.Calls.normalize.banners = function (raw) {
    if (raw && Array.isArray(raw.banners)) return raw;
    if (!raw || !Array.isArray(raw.records)) return { banners: [] };
    const regionMap = {
        'full banner': 'full', 'mini banner': 'mini', 'top': 'topo',
        'footer': 'rodape', 'stripe': 'tarja', 'popup': 'popup',
        'category description': 'category_description'
    };
    const toTipo = (n = '') => {
        const l = n.toLowerCase(), adv = l.match(/^advanced\s*(\d+)$/);
        if (adv) return 'advanced' + adv[1];
        return regionMap[l] || l.replace(/\s+/g, '');
    };
    const deviceMap = { all: 'T', desktop: 'D', mobile: 'M' };
    return {
        banners: raw.records.map(r => ({
            id: r.id,
            tipo: toTipo(r.region?.name),
            imagem: r.image || '',
            titulo: r.name || '',
            dispositivos: deviceMap[r.device] || 'T',
            conteudo: r.content || '',
            altura: String(r.height ?? 0),
            largura: String(r.width ?? 0),
            url: r.url || '',
            target: r.target || '_self'
        }))
    };
};

// ----------------------------------------------------------------
// Inicialização
// ----------------------------------------------------------------
ApiWS.version = '2.0';
ApiWS.LV = document.querySelector('#HD_LV_ID')?.value || '';

(function () {
    // Todas as chamadas passam pelo proxy NestJS (mesmo origem) — nunca direto à API V3
    // O proxy em /api/proxy/* repassa para a V3 adicionando o Bearer token do cookie HttpOnly
    ApiWS.UrlApi = window.location.origin + '/api/proxy';
})();

ApiWS.dashview = window.__WS_CONFIG__?.dashview === true;
ApiWS.debug = window.__WS_CONFIG__?.clientDebug === true;
ApiWS.LVdashview = null;
ApiWS.FileReturn = null;
ApiWS.Json = null;
ApiWS.objetosReturn = null;

ApiWS.ApiStart = function () {
    ApiWS.Origin.capture();
    try {
        console.log(`ws-wsjs v${ApiWS.version}`);
        ApiWS.LV = document.querySelector('#HD_LV_ID')?.value || '';
        ApiWS.LVdashview = '';
        try {
            if (window.location.search.includes('dashview')) localStorage['dashview'] = '1';
            if (localStorage['dashview'] === '1') ApiWS.LVdashview = '1';
            if (ApiWS.LVdashview === '1') ApiWS.dashview = true;
            console.log('LVdashview:' + ApiWS.LVdashview);
        } catch (e) { }
        window.setInterval('keepWsBrand()', 3000);
        ApiWS.User.validateAndSync();
    } catch (e) {
        console.error('[ApiWS] ApiStart failed:', e.message);
    }
};

function keepWsBrand() {
    document.querySelectorAll('div[class*="LV_RODAPE_"]').forEach(el => el.style.display = '');
}
